<template>
  <small class="text-sm font-medium text-foreground  leading-5">
   <slot />
  </small>
</template>